import { createContext, useContext } from "react";

/** Signals that an ancestor already compensates for the keyboard (RN-5354). */
export interface KeyboardAvoidanceContextValue {
  avoidedByAncestor: boolean;
}

export const KeyboardAvoidanceContext = createContext<KeyboardAvoidanceContextValue>({
  avoidedByAncestor: false,
});

export const useKeyboardAvoidance = (): KeyboardAvoidanceContextValue =>
  useContext(KeyboardAvoidanceContext);
